module.exports = {"id":"207641","name":"Bryan Carrasco","rating":"71","photo":"./data/images/photos/4/207641.png","club":{"name":"Audax Italiano","logo":"./data/images/clubs/AudaxItaliano.png"},"positions":["MD","MC","AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BryanCarrasco0.json
// module id = 673
// module chunks = 0